import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./pages/menu/menu.module').then( m => m.MenuPageModule)
  },
  {
    path: 'thread-tab',
    loadChildren: () => import('./pages/thread-tab/thread-tab.module').then( m => m.ThreadTabPageModule)
  },
  {
    path: 'thread-data',
    loadChildren: () => import('./pages/thread-data/thread-data.module').then( m => m.ThreadDataPageModule)
  },
  {
    path: 'thread-dash',
    loadChildren: () => import('./pages/thread-dash/thread-dash.module').then( m => m.ThreadDashPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules, relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
